module.exports = __webpack_public_path__ + "static/media/2-conference-room.4a6d39e4.png";